"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentOccurrenceTypeEnum = exports.SegmentTypeEnum = exports.EventSortByFieldsEnum = exports.SegmentSortByFieldsEnum = void 0;
var SegmentSortByFieldsEnum;
(function (SegmentSortByFieldsEnum) {
    SegmentSortByFieldsEnum["NAME"] = "name";
    SegmentSortByFieldsEnum["DATE"] = "startDate";
})(SegmentSortByFieldsEnum = exports.SegmentSortByFieldsEnum || (exports.SegmentSortByFieldsEnum = {}));
var EventSortByFieldsEnum;
(function (EventSortByFieldsEnum) {
    EventSortByFieldsEnum["DATE"] = "startDate";
    EventSortByFieldsEnum["TIME"] = "startTime";
})(EventSortByFieldsEnum = exports.EventSortByFieldsEnum || (exports.EventSortByFieldsEnum = {}));
var SegmentTypeEnum;
(function (SegmentTypeEnum) {
    SegmentTypeEnum["SLOT"] = "slot";
    SegmentTypeEnum["DATE"] = "date";
    SegmentTypeEnum["CUSTOM"] = "custom";
})(SegmentTypeEnum = exports.SegmentTypeEnum || (exports.SegmentTypeEnum = {}));
var SegmentOccurrenceTypeEnum;
(function (SegmentOccurrenceTypeEnum) {
    SegmentOccurrenceTypeEnum["WEEK"] = "week";
    SegmentOccurrenceTypeEnum["MONTH"] = "month";
})(SegmentOccurrenceTypeEnum = exports.SegmentOccurrenceTypeEnum || (exports.SegmentOccurrenceTypeEnum = {}));
//# sourceMappingURL=program-season.enums.js.map